import * as React from 'react';
import { FC } from 'react';

import { ISanityTextNode } from '@rbi-ctg/menu';
import LoadingAnimation from 'components/loading-animation';
import { Animation as NewBadgeAnimation } from 'components/lottie-animations/loyalty-new-badge';
import { ResponsiveCarousel } from 'components/responsive-carousel';
import { useLoyaltyContext } from 'state/loyalty';
import { useLoyaltyNotifications } from 'state/loyalty/hooks/use-loyalty-notifications';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import LoyaltyNotificationCard from './loyalty-notification-card';
import {
  Container,
  HeadingContainer,
  HeadingText,
  LoadingContainer,
  NewBadgeContainer,
} from './loyalty-notifications-widget.styled';

/**
 *
 * LoyaltyNotificationsWidget shows a section with loyalty notifications
 *
 */
const LoyaltyNotificationsWidget: FC<{
  title: ISanityTextNode;
}> = ({ title }) => {
  const { loyaltyUser } = useLoyaltyUser();
  const { loyaltyOffersEnabled } = useLoyaltyContext();
  const { notifications, loadingNotifications } = useLoyaltyNotifications(
    loyaltyUser,
    loyaltyOffersEnabled
  );

  if (loadingNotifications) {
    return (
      <LoadingContainer data-testid="widget-loader">
        <LoadingAnimation />
      </LoadingContainer>
    );
  }

  if (!notifications.length) {
    return null;
  }

  return (
    <Container>
      <HeadingContainer>
        <HeadingText>{title.locale}</HeadingText>
        {NewBadgeAnimation && (
          <React.Suspense fallback={null}>
            <NewBadgeContainer>
              <NewBadgeAnimation />
            </NewBadgeContainer>
          </React.Suspense>
        )}
      </HeadingContainer>
      <ResponsiveCarousel>
        {notifications.map((notification, idx) => (
          <LoyaltyNotificationCard
            notification={notification}
            idx={idx}
            key={notification?.title?.locale || idx}
          />
        ))}
      </ResponsiveCarousel>
    </Container>
  );
};

export default LoyaltyNotificationsWidget;
